// extracted by mini-css-extract-plugin
export var productImage = "_pt-1";
export var viewLink = "_pt-2";
export var wishlistItem = "_pt-0";